/**
 * Brand mark for inonit. Uses the actual logo asset shipped at
 * `/inonit-logo.png` (full lockup) and `/inonit-mark.png` (icon only).
 * The image background is cream (#F4F0E1) to match `bg-paper` so it sits
 * seamlessly in any paper-coloured surface without needing transparency.
 *
 * Sizing is driven by Tailwind height classes — width is fluid (auto)
 * so the natural aspect ratio is preserved at every breakpoint.
 *
 *   <Logo />                    → full lockup (icon + wordmark), nav default
 *   <Logo variant="mark" />     → icon only (square-ish)
 *   <Logo heightClassName="h-9 md:h-11" />
 */
export default function Logo({
  variant = "full",
  heightClassName = "h-7 md:h-9",
  className = "",
  alt = "inonit",
  testid = "logo-image",
}) {
  const src = variant === "mark" ? "/inonit-mark.png" : "/inonit-logo.png";
  return (
    <img
      src={src}
      alt={alt}
      data-testid={testid}
      draggable={false}
      className={`${heightClassName} w-auto select-none ${className}`}
    />
  );
}
